module.exports = __webpack_public_path__ + "static/media/gg_bk.f0cf37ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/gg_bk.png
// module id = 426
// module chunks = 0